const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamspiritCuate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.52,228.42a38,38,0,0,1-.13,4.9c.07-1.09.08-2.18.1-3.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,333.44c-.23.47.55.85.8.41A104,104,0,0,0,99.1,294.42a54.68,54.68,0,0,0,11.6-20.59h.06c6.53-.93,13.43-2.65,17.11-8.62,3.42-5.56,4-13.47,4.58-19.77l.11-.11a.27.27,0,0,0-.35-.4,93.17,93.17,0,0,0-14,12.9c-3.64,4.24-5,9.12-7,14.13a102.37,102.37,0,0,0,3.59-27.91.32.32,0,0,0,.09-.35l-.09-.29v-.31s0,0,0-.08c4.25-4.58,7.79-8.07,8.15-14.55.44-8-3.1-14.36-6.27-21.41a.35.35,0,0,0-.63,0c-2.61,5.54-5.87,11.44-6.32,17.65-.49,6.58,2,13.2,4.39,19.22a.37.37,0,0,0,.17.18c-1.74,17.51-5.64,33.71-15,48.66,3-26.11-3.39-52.87-14.2-77.69v-.05c15.34-5.76,11.21-20.61,9.2-33.53a5.76,5.76,0,0,0-.1-.67s0,0,0,0h0c0-.07,0-.09-.1-.06S86,191.46,84.38,197.41c-1.3,4.86-.72,10.19-.36,15.29-2.16-4.82-4.48-9.57-6.94-14.21l0-.86a.11.11,0,0,0,.06-.18l0-.07c.19-5.67.37-11.33-2-16.65-2.73-6.14-7.91-11.18-12.75-15.72,0-.08-.33.05-.32.07-.68,6.41-2,14.33.8,20.43,2.57,5.62,8.81,8.75,13.33,12.54l.11.06c8.47,20.38,17.46,40.69,20.8,62.57a100.09,100.09,0,0,1-24.94-23.17c3.84-3.58,6.43-7.57,6.12-13a35.29,35.29,0,0,0-8-20.11h0a.26.26,0,0,0-.17-.09.35.35,0,0,0-.42.47c-4.58,10-4.52,18.59-1.06,28A154.68,154.68,0,0,1,58.5,215.85c3-11.21-7.08-17.12-13.85-24.47-.19-.21-.58,0-.43.28.06.1.13.19.19.28-1.26,11.67,3.3,20.79,14,26.24a.6.6,0,0,0,.22.06,85.06,85.06,0,0,0,17.75,27.13,24.8,24.8,0,0,0-8.55-4c-6.08-1.42-11.32,1.14-17,2.94a.33.33,0,0,0-.15,0l-.09,0a.48.48,0,0,0-.07.9l.05,0c8.68,5.67,20.73,13.28,30,4.37l.62.38A106.79,106.79,0,0,0,97,262.16a.67.67,0,0,0,.29.1c.27,1.92.51,3.85.68,5.8a117.57,117.57,0,0,1-5.65,47.18c-7.53-10.53-12.81-20.73-15.53-33.61,2.71-10.47-3.12-18.44-10.33-25.82h0a.26.26,0,0,0-.48.1c-1,5-2.58,11.5-.75,16.44s6.59,8.14,10.89,10.58l.1,0A73.72,73.72,0,0,0,81,299.63a28.24,28.24,0,0,0-9.32-9.41c-4.89-2.84-9.75-2.69-15.25-2.27-.44,0,6.76,19.34,25.18,13.66l.61.74a58.65,58.65,0,0,0,9.59,14.47A142.24,142.24,0,0,1,85,333.44ZM81.11,301c-5.08.09-10.47.49-15-2.31-4.16-2.58-5.87-6-8.91-9.88,5.54.31,10-.38,15.19,3.13C76,294.29,78.48,297.71,81.11,301ZM76,281.67c-4.54-2.6-8.91-6.24-9.84-11.55-.78-4.46.12-9,.31-13.54,2.49,3.26,5,6.58,7.15,10,3.14,5,3,9.28,2.6,14.66a.34.34,0,0,0-.22.38ZM57.59,216.22A27.76,27.76,0,0,1,48,207.06c-2.76-4.59-2.34-9.37-3.15-14.39,2,2.91,4.64,5.06,7.16,7.56C56.62,204.76,58.61,209.84,57.59,216.22ZM72,235.94l-.19.22a80.92,80.92,0,0,1-2.62-14.89c-.29-4.86.74-9.59,1-14.4a97.71,97.71,0,0,1,2,14.68c.11,2.16.32,4.51.4,6.87,0-2.29,0-4.58-.08-6.87A74.43,74.43,0,0,0,70.19,206a1.62,1.62,0,0,0,0-.22c1.64,5.58,4.92,10.52,5.34,16.46a22.54,22.54,0,0,1-3.41,13.46,19.08,19.08,0,0,0,.26-2.37A18.83,18.83,0,0,1,72,235.94Zm-2-29.83a2.38,2.38,0,0,0,0,.26A71.14,71.14,0,0,0,68.9,221.7a86.59,86.59,0,0,0,2.74,14.62l-.12.14c-2-5.69-4.64-11.36-4.27-17.54C67.5,214.61,69,210.35,70,206.11Zm3.1,28.45a21.79,21.79,0,0,0,2.78-11.24c-.11-6.19-3.32-11.32-5.32-17,2.24,4.26,4.39,8.24,5.56,13.07C77.75,226.08,76.6,230.07,73.1,234.56Zm6.61,14.64c-4.4,2.33-8.68,3.88-13.88,2.94S56.4,247.85,52.14,245c5.14-1.19,9.85-3.56,15.3-2.3C72.16,243.82,75.75,246.71,79.71,249.2Zm-4-56.55A74.44,74.44,0,0,0,63.2,166.24c4,4.34,7.72,8.57,10.19,14.06C75.24,184.4,75.29,188.51,75.69,192.65Zm.15,3.23A209.26,209.26,0,0,0,63.1,166.61,84.63,84.63,0,0,1,76,194.8c.07.49.15,1,.24,1.48ZM66,182.3c-2.05-5.17-2.41-11-3.38-16.41a270.61,270.61,0,0,1,13.13,29.86C72.09,191.57,68,187.45,66,182.3Zm9.74,13.84c-4.14-3.34-9.15-6.39-11.33-11.38-2.29-5.27-2-13.44-2-19.21.74,5.72,1.28,12,3.52,17.32C68,187.89,72.05,192.09,75.72,196.14Zm10.72,6.19h0c.9-7.25,4.83-13,7.4-19.63a57.59,57.59,0,0,1-2.15,15.6c-1.48,5.38-4.26,10.22-6.51,15.29.18-3.25.48-6.47,1-9.7,0,0,0,0-.06,0a58.37,58.37,0,0,0-1.2,9.13c-.14-5.49-.24-11.76,1.39-16.8,1.77-5.46,5.06-9.59,7.53-14.47V182C90.73,188.35,87.21,195.26,86.44,202.33ZM94.19,185c.38,5.14.85,10.39-.37,15.39a27.37,27.37,0,0,1-8.64,13.81A79.89,79.89,0,0,0,92,198.38a63.89,63.89,0,0,0,1.55-8.12C93.77,188.52,94.06,186.73,94.19,185Zm-9.06,29.66c0-.12,0-.23,0-.34a26.52,26.52,0,0,0,8.57-12.79,31.93,31.93,0,0,0,1.18-11.17,48.4,48.4,0,0,1,.45,7C95.16,205.25,91.57,210.4,85.13,214.61Zm29.48,28.13c-1.92-5.88-4.21-12.73-3.42-18.84.32-2.54,4.91-15,5.24-15.19,0,0,5.16,12.3,5.07,18.58C121.39,234.11,117.25,237.21,114.61,242.74Zm-3.33,30c2.72-4.82,3.93-10,7.69-14.38,4-4.58,8.61-8.49,13.06-12.57-1.26,5.14-1.76,10.56-3.65,15.51C125.43,269.06,118.66,271.2,111.28,272.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.15,215.39c.15.36.31.73.46,1.1,0,.1.2.07.17,0s-.14-.41-.2-.61l.31.32c0,.34.11.68.15,1a0,0,0,0,0,.07,0c0-.31-.09-.61-.14-.91l.42.44a0,0,0,1,0,0,0c-.15-.17-.31-.33-.46-.49-1.38-8.82-6.42-16.21-12.28-22.78-.15-.24-.29-.5-.45-.74,0,0,0,0-.07,0a.09.09,0,0,0-.15,0l-.17-.19c-.05,0-.13,0-.09.07l.31.45a59.12,59.12,0,0,0,4.47,12.87C51.42,209.58,54.29,212.43,57.15,215.39ZM45.81,194c3.74,7.1,8.11,13.87,11.28,21.26-2.78-2.93-5.5-5.91-7.32-9.55a69.45,69.45,0,0,1-4.36-12.25Zm11.74,21.74c-1.22-3.76-3.3-7.18-5.21-10.6-1.81-3.24-3.59-6.5-5.45-9.71,2.14,2.77,4.43,5.43,6.35,8.37a31.7,31.7,0,0,1,4.64,12.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.09,245.35l1.17-.26c1.88,1.66,4.54,2.72,6.77,3.72A27.16,27.16,0,0,0,66.11,251a24,24,0,0,0,13.52-2l.56.25a0,0,0,0,0,0-.08h0a0,0,0,0,0,0-.07l-.34-.11-.1-.06.66-.31s0,0,0,0l-.7.31a44,44,0,0,0-14-5.1c-4.56-.67-9.13.08-13.6,1l-.22-.15s0,0,0,0l.15.13h-.19a0,0,0,0,0,0,0l-.8.18C50.89,245.16,51,245.38,51.09,245.35Zm27.67,3.31a77,77,0,0,0-25.37-3.8,36.07,36.07,0,0,1,12.33-.73C70.25,244.81,74.57,246.8,78.76,248.66Zm-26.33-3.6.11,0a86.87,86.87,0,0,1,27,4l.06,0C70.35,253,60.56,250.54,52.43,245.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.86,282.45c0,.13.2.13.21,0s0-.42,0-.62l.52.54a.08.08,0,0,0,.11-.11l-.63-.69c.16-8.84-3.51-16.68-8.66-23.63-.24-.5-.49-1-.75-1.49,0,0-.07,0-.06,0,.12.29.25.57.37.86l-.32-.43c0-.08,0-.16,0-.24a0,0,0,1,0,0,0v.16l-.15-.19c0-.05-.1,0-.08.05s.15.22.23.32c0,4.67.09,9.42,1.75,13.84,1.53,4.07,4.41,7.48,7.38,10.61,0,.08,0,.16,0,.24s.07,0,.07,0l0-.13,0,0C75.86,281.88,75.87,282.16,75.86,282.45Zm0-1.13-.12-.12a51.28,51.28,0,0,0-3.24-10.55h0a57.9,57.9,0,0,1,3.18,10.46c-3-3.34-5.89-6.76-7.31-11.16-1.33-4.12-1.48-8.53-1.69-12.83l.56.82c1.35,3.14,2.8,6.24,4,9.43,0,0,0,0,0,0-1.08-2.87-2.15-5.73-3.43-8.49A46.36,46.36,0,0,1,73.56,269,37.8,37.8,0,0,1,75.86,281.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,288.94l.33.07c5.89,6.94,15.12,12.2,24.38,11.92,0,0,0-.06,0-.07-5.11-.58-9.61-1.49-14.19-4a38.39,38.39,0,0,1-9.94-7.85l.61.11A107.39,107.39,0,0,1,80.36,300l.44.42s0,0,0,0l-.27-.28c.24.16.48.3.72.47,0,0,.09,0,0-.07-.44-.35-.9-.68-1.36-1-2.94-3-6-5.87-10-7.62a46.77,46.77,0,0,0-12.29-3.14l-.49-.15-.3-.33c-.05,0-.13,0-.08.09s.11.13.17.2a.07.07,0,0,0,0,.13C56.91,288.76,56.9,288.92,57,288.94Zm2.9.54a43.06,43.06,0,0,1,9.89,2.72c3.66,1.63,6.69,4.26,9.61,7A75.4,75.4,0,0,0,59.94,289.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.44,243.14a2,2,0,0,1,0-.23.12.12,0,0,0,.09-.07c2.54-5,4.85-11,5.16-16.64a34.33,34.33,0,0,0-.91-8.38,86.12,86.12,0,0,0-2.39-9.91.14.14,0,0,0-.27.07c.11.52.22,1.05.34,1.57,0,5.68.18,11.37-.37,17-.51,5.31-1.45,10.55-1.72,15.89l-.09.22a.14.14,0,0,0,.07.2c0,.09,0,.17,0,.25S114.44,243.2,114.44,243.14Zm.06-.92c.32-5.24,1.37-10.41,1.86-15.63a116.92,116.92,0,0,0,.19-16.74c1.19,5.09,2.76,10.24,2.74,15.47C119.26,231.1,116.79,237,114.5,242.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.19,243.31c-.23-5.7-2.45-10.93-1.94-16.71a46.06,46.06,0,0,1,3.43-14.41s.08,0,.07,0a48.18,48.18,0,0,0-3.3,15.6c-.26,5.26,1.67,10.26,1.86,15.49A.06.06,0,0,1,114.19,243.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5,272.85c.39,0,.78-.09,1.17-.14,0,.05,0,.11.11.07l.19-.12.26,0c0,.05-.07.1-.1.16s.1.21.19.1.15-.21.23-.32a25.3,25.3,0,0,0,14.8-9.49c3.81-5,4.21-11.75,6.11-17.53a.11.11,0,0,0-.2-.09c-.18.4-.34.8-.5,1.21.07-.25.16-.49.23-.74,0,0-.05-.06-.07,0-2.39,5.33-4.77,10.49-8.41,15.12a54.73,54.73,0,0,1-11.21,10.5c3-4.26,5.58-8.82,8.94-12.9,3.53-4.28,7.13-8.49,10.67-12.76a0,0,0,0,0-.06-.06c-4.07,4.14-7.67,8.83-11.35,13.33-3.3,4-5.85,8.53-8.8,12.81l-.44.32c-.58.1-1.17.19-1.75.24C109.28,272.51,109.27,272.86,109.5,272.85Zm2.43-.81c8.17-5.38,15.69-14,19.13-23.27-1.21,4.18-1.62,8.63-3.89,12.42a24.53,24.53,0,0,1-15.31,10.95Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,316.61s.58,5.21,1.39,12.61c1.91,17.44,5.13,47,5.13,48.82h28.93c0-1.8,3.2-31.38,5.11-48.82.8-7.4,1.38-12.61,1.38-12.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,316.61s.58,5.21,1.39,12.61H109.6c.8-7.4,1.38-12.61,1.38-12.61Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.4,
    y: 314.53,
    width: 47.23,
    height: 9.2,
    transform: "translate(180.02 638.26) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.84,
    cy: 91.64,
    r: 32.8,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.34,
    cy: 92.37,
    r: 31.3,
    transform: "translate(-13.38 152.45) rotate(-45)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.34,
    cy: 92.37,
    r: 29.32,
    transform: "translate(-21.72 73.44) rotate(-22.08)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.97,
    y: 65.18,
    width: 0.75,
    height: 4.44,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.48,
    y: 68.52,
    width: 0.75,
    height: 4.44,
    transform: "translate(-13.29 91.89) rotate(-29.99)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.34,
    y: 77.66,
    width: 0.75,
    height: 4.44,
    transform: "translate(8.68 174.81) rotate(-60.01)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.15,
    y: 92,
    width: 4.44,
    height: 0.75,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.49,
    y: 104.48,
    width: 4.44,
    height: 0.75,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -31.57, 91.92)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.63,
    y: 113.62,
    width: 4.44,
    height: 0.75,
    transform: "translate(-16.25 199.88) rotate(-60.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.97,
    y: 115.12,
    width: 0.75,
    height: 4.44,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.45,
    y: 111.78,
    width: 0.75,
    height: 4.44,
    transform: "translate(-31.57 110.2) rotate(-30)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.59,
    y: 102.64,
    width: 0.75,
    height: 4.44,
    transform: "translate(8.67 224.74) rotate(-60)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.09,
    y: 92,
    width: 4.45,
    height: 0.75,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.75,
    y: 79.51,
    width: 4.44,
    height: 0.75,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -13.28, 110.2)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.6,
    y: 70.37,
    width: 4.44,
    height: 0.75,
    transform: "translate(33.72 199.86) rotate(-60.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.41,
    y: 95.41,
    width: 28.37,
    height: 0.75,
    transform: "translate(10.61 208.86) rotate(-63.04)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 82.13,
    width: 1,
    height: 27.94,
    transform: "translate(-15.4 36.81) rotate(-11.32)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--xsrjP0--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.78,104.1c-.83-.52-1.56-1.29-2.67-1.18-.43,0-.34-.31-.34-.54q0-6.3,0-12.6c0-.3,0-.55.35-.72,3.21-1.62,4.6-4.8,6.56-7.52A12.56,12.56,0,0,0,313,72c-.13-1,.31-1.37,1.16-1.57a2.1,2.1,0,0,1,2.39.76,16.6,16.6,0,0,1,1.83,5.5c.19,1.59-.38,3.14-.58,4.72-.15,1.15-.41,2.29-.63,3.46.28.2.6.09.91.1h10.64c1.49,0,2.22.43,2.43,1.42a2.84,2.84,0,0,1-1.54,3.08c-.27.13-.75,0-.78.43s.46.38.71.55c1.28.88,1,2.69-.45,3.74-.35.26-1,.14-1.06.66s.64.42.93.71c1,1,.52,2.94-1,3.71a6.62,6.62,0,0,0-.62.24c-.18.12-.35.25,0,.49,1.54,1.1,1.51,2.63,0,3.74l-.46.33a2.94,2.94,0,0,1-1.87.41H308.25A2,2,0,0,1,306.78,104.1Z",
    style: {
      fill: "#dbdbdb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,96.69c0-2.66,0-5.33,0-8,0-.54.05-.81.72-.8q4.88.06,9.75,0c.64,0,.74.22.74.78q0,8.06,0,16.11c0,.68-.18.87-.87.86-3.15,0-6.31,0-9.46,0-.79,0-.89-.26-.89-1C291,102,291,99.36,291,96.69Z",
    style: {
      fill: "#dbdbdb",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "391.92 181.34 393.86 185.29 398.22 185.92 395.07 189 395.81 193.33 391.92 191.28 388.02 193.33 388.77 189 385.62 185.92 389.97 185.29 391.92 181.34",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.84 159.56 86.79 163.51 91.14 164.14 87.99 167.21 88.73 171.55 84.84 169.5 80.94 171.55 81.69 167.21 78.54 164.14 82.89 163.51 84.84 159.56",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.78 161.08 423.99 163.52 426.68 163.91 424.73 165.81 425.19 168.49 422.78 167.22 420.38 168.49 420.84 165.81 418.89 163.91 421.58 163.52 422.78 161.08",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.32 140.72 129.52 143.16 132.22 143.55 130.27 145.45 130.73 148.13 128.32 146.86 125.91 148.13 126.37 145.45 124.43 143.55 127.12 143.16 128.32 140.72",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.96 140.34 411.7 141.84 413.37 142.08 412.17 143.26 412.45 144.91 410.96 144.13 409.47 144.91 409.76 143.26 408.56 142.08 410.22 141.84 410.96 140.34",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.71 97.15 104.45 98.66 106.11 98.9 104.91 100.08 105.19 101.73 103.71 100.95 102.22 101.73 102.5 100.08 101.3 98.9 102.96 98.66 103.71 97.15",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.11,240.76V378h83V240.76Zm75.45,86.61H339.65V291.64h67.91Zm0-44.24H339.65V247.4h67.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.09,
    y: 240.76,
    width: 33.18,
    height: 137.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.65,
    y: 247.39,
    width: 16.14,
    height: 35.73,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.06,369.92H339.57V334.85h68.49Zm-67.49-1h66.49V335.85H340.57Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.28,
    y: 344.93,
    width: 13.4,
    height: 6.78,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.15,351.7h-14.4v-6.76h14.4Zm-13.4-1h12.4v-4.76h-12.4Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.65,
    y: 291.64,
    width: 16.14,
    height: 35.73,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-86"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.32,
    cy: 433.11,
    rx: 116.92,
    ry: 18.48,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.83,
    cy: 442.05,
    rx: 109.24,
    ry: 17.26,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 371.17,
    cy: 442.05,
    rx: 109.24,
    ry: 17.26,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-86"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "18 378.04 76 377.79 134 377.71 250 377.54 366 377.7 424 377.79 482 378.04 424 378.28 366 378.37 250 378.54 134 378.37 76 378.28 18 378.04",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.27,272c1.32,3.83-.12,10,2.89,9.87,2.68-.09,3.26-4.43,3.26-4.43s.93,5.1,3.78,4.19,2.53-5.8,2.53-5.8.58,4.28,3.36,3.17,3.27-5.32,3.27-5.32,1,1.11,2.62-.56c2.31-2.39,1.33-9.51-.07-13.11s-9.16-15.73-10.38-17.57l-23.16,8.76s-.47,7.54-.24,11.39,4.5,16.33,7.67,15.48,0-9.61-.31-11.93.18-2.78,1.13-1.84C287.24,264.94,289.69,270.34,290.27,272Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.35,277.25c.38-6.1-.5-8.84-3.39-14.13-.06-.1.08-.21.15-.1,3.3,4.91,4.91,8.19,3.53,14.27C296.58,277.58,296.33,277.54,296.35,277.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.65,276.12c-.15-6.38-1.09-9.36-3.7-15.12,0-.08.09-.15.14-.07,3,5.43,4.57,8.74,3.88,15.13C302.94,276.35,302.66,276.41,302.65,276.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.3,273.64c-.59-6.16-1.48-9.47-4.73-14.73a.11.11,0,1,1,.18-.13c3.85,5,5,9.16,4.74,14.83C309.47,274,309.34,274,309.3,273.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78,170.12c15.61,19.32,36.74,66.67,39.27,73.41,1.72,4.58-22.28,14.21-23,10.92-.9-4.2-16.59-56.5-20.28-76C256.76,167.63,259.55,166.13,262.78,170.12Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.58,183.36c2.57,17.85,17.91,67.37,17.91,67.37l18.19-6.92,9.18-3.5s-26-49.45-36.93-65.83c-.85-1.26-1.63-2.35-2.35-3.26C257.68,162.44,256.6,169.61,258.58,183.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.79,235.21a7.57,7.57,0,0,1,0-3.86,7.57,7.57,0,0,1,0,3.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.75,172.77a6.8,6.8,0,0,1-.25-1.94,6.73,6.73,0,0,1,.25-1.93,7.11,7.11,0,0,1,.25,1.93A7.18,7.18,0,0,1,261.75,172.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.1,225.33a7.57,7.57,0,0,1,3.86,0,7.57,7.57,0,0,1-3.86,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.66,200.63a7.61,7.61,0,0,1,3.87,0,6.44,6.44,0,0,1-1.93.25A6.8,6.8,0,0,1,272.66,200.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.33,214.8a7,7,0,0,1-1.54-1.19,6.67,6.67,0,0,1-1.19-1.54,7.65,7.65,0,0,1,2.73,2.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.18,184.47a7,7,0,0,1-1.54-1.19,6.67,6.67,0,0,1-1.19-1.54,6.67,6.67,0,0,1,1.54,1.19A7,7,0,0,1,268.18,184.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.92,234.38a7.58,7.58,0,0,1-2.74-2.73,6.73,6.73,0,0,1,1.55,1.19A7.27,7.27,0,0,1,273.92,234.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,214a7.33,7.33,0,0,1-1.19,1.55,7,7,0,0,1-1.55,1.19A7.5,7.5,0,0,1,274.6,214Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.62,241a7.58,7.58,0,0,1-2.73,2.74,6.79,6.79,0,0,1,1.19-1.55A7,7,0,0,1,286.62,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.81,191.32a7.65,7.65,0,0,1-2.73,2.73,7.65,7.65,0,0,1,2.73-2.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.48,245.39c10.8-5.09,22.91-8.79,25-9.59a.08.08,0,0,1,.05.16c-2.07.68-15.45,6.41-25,9.6C275.42,245.6,275.38,245.44,275.48,245.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.91,244.48l-16.42,6.25s-15.34-49.52-17.91-67.37c-1.3-9-1.28-15.2.83-15.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.56,381.23s0,36.89,0,36.92c0,7.05.06,13.24.4,16.43a.13.13,0,0,0,0,.06,5,5,0,0,0,.51,2.18s0,0,0,0c2.09,1.44,58.47,3.37,60.46,2.77s.45-6.31-1.68-8.13-23.39-12.21-23.39-12.21l-.36-36.88Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.57,410.57v7.58c0,7.05.06,13.24.4,16.43a.13.13,0,0,0,0,.06,9.51,9.51,0,0,0,.51,2.18s0,0,0,0c2.09,1.44,58.47,3.37,60.46,2.77s.45-6.31-1.68-8.13-23.39-12.21-23.39-12.21l.1-7.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,439.63c-2,.6-58.36-1.33-60.46-2.77-.81-.53-1-8.76-1-18.71v-.31l36.38.83,0,.62s21.25,10.39,23.39,12.21S309,439.05,307,439.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.43,437.43c-9.5-.56-47.85-1.92-57.27-1.75-.08,0-.08.05,0,.06,9.4.76,47.76,1.8,57.27,1.84C306.62,437.58,306.63,437.44,306.43,437.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,419.51c-3.71-.83-8.3-.41-11.25,2.15-.12.1,0,.26.15.23A52,52,0,0,1,284.94,420,.24.24,0,0,0,285,419.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.62,421.22c-3.72-.82-8.31-.4-11.26,2.16-.11.1,0,.26.15.23a51.93,51.93,0,0,1,11.08-1.91A.24.24,0,0,0,287.62,421.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.26,422.94c-3.71-.82-8.31-.4-11.26,2.16-.11.1,0,.26.16.23a51.73,51.73,0,0,1,11.07-1.91A.24.24,0,0,0,290.26,422.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.33 244.43 243.74 354.7 244.57 419.7 284.03 418.92 276.31 242.23 275.92 222 242.6 222 242.33 244.43",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.38,412.33c-6.16-.05-4.4-.12-10.56-.11-3,0-22.83.08-25.64.58a.06.06,0,0,0,0,.12c2.82.44,22.63,0,25.64,0,6.16-.14,4.39-.17,10.55-.37A.09.09,0,0,0,282.38,412.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.8,251.24c0-.08.13-.08.13,0,0,10.31.32,20.63.57,30.94s.55,20.63.83,30.95c.56,20.61,1.39,41.22,2.15,61.83q.64,17.34,1.6,34.67c0,.07-.11.07-.12,0-1.49-20.59-2.93-41.18-3.74-61.81s-1.41-41.23-1.51-61.86C264.66,274.39,264.82,262.82,264.8,251.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.33 244.43 243.74 354.7 270.19 222 242.6 222 242.33 244.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.71,382.33S233,417.5,233,417.52c0,7.06-.21,13.24-.59,16.44a.11.11,0,0,1,0,.05,5,5,0,0,1-.53,2.17l0,.05c-2.11,1.41-58.51,2.69-60.49,2.07s-.38-6.31,1.77-8.11,23.53-11.94,23.53-11.94l5.92-36.85Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.6,410c-.37,4.41-.62,7.53-.62,7.55,0,7.06-.21,13.24-.59,16.44a.11.11,0,0,1,0,.05,9.47,9.47,0,0,1-.53,2.17l0,.05c-2.11,1.41-58.51,2.69-60.49,2.07s-.38-6.31,1.77-8.11,23.53-11.94,23.53-11.94l.7-7.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.32,438.3c2,.62,58.37-.66,60.49-2.07.81-.53,1.1-8.75,1.17-18.71v-.31l-36.39.42,0,.62s-21.37,10.14-23.53,11.94S169.33,437.69,171.32,438.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.91,436.1c9.5-.45,47.86-1.36,57.28-1.09.08,0,.08.06,0,.06-9.41.65-47.78,1.26-57.29,1.19C171.71,436.25,171.71,436.11,171.91,436.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.54,417.83c3.73-.78,8.32-.31,11.24,2.29.11.1,0,.26-.16.22a52.49,52.49,0,0,0-11.05-2A.24.24,0,0,1,192.54,417.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.88,419.52c3.73-.79,8.31-.32,11.23,2.28.12.11,0,.26-.15.23a52.49,52.49,0,0,0-11.05-2A.24.24,0,0,1,189.88,419.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.22,421.21c3.72-.79,8.31-.32,11.23,2.28.11.1,0,.26-.15.23a52.47,52.47,0,0,0-11.06-2A.24.24,0,0,1,187.22,421.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.53,222v0c-.14.69-2.47,11.5-4.89,20.79-1.76,6.78-3.56,12.75-4.6,13.36s-6.9,3.23-8.82,4l-8.75,83.75-11.74,75.34-39.37-2.06L225.93,222Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.52,412.07c-6.15-.4-4.38-.37-10.53-.7-3-.16-22.79-1.21-25.63-.87a.06.06,0,0,0,0,.12c2.79.6,22.59,1.3,25.6,1.4,6.16.22,4.4.09,10.55.23A.09.09,0,1,0,233.52,412.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,390.6q1.44-8.07,2.91-16.14,3-16.15,6-32.28,6.06-32.3,12-64.62c2.22-12.18,2.16-11,4.09-23.26,0-.08.15-.07.14,0-1.86,10.86-1,8.48-2.73,19.36s-3.58,21.53-5.51,32.27c-3.87,21.58-7.93,43.12-12,64.66q-1.72,9.06-3.5,18.1c-1.2,6.16-2.57,12.27-3.84,18.41,0,.14-.24.12-.22,0C209.16,401.6,210,396.09,211,390.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.62,255.1c1-.26,2.13-.35,3.18-.51.85-.14,1.7-.29,2.54-.47a11.15,11.15,0,0,0,4.47-1.88,10.64,10.64,0,0,0,2.9-4.51c.42-1,.85-2,1.29-2.93.21-.47.42-.94.64-1.41a16.24,16.24,0,0,0,.8-1.69c0-.09.16,0,.12,0-.16.39-.23.82-.35,1.22s-.28,1-.43,1.42c-.26.85-.52,1.69-.79,2.53a20.09,20.09,0,0,1-1.8,4.43c-1.55,2.48-4.33,3.47-7.11,3.82-.79.1-1.6.16-2.4.21a18,18,0,0,1-3,0C221.5,255.36,221.45,255.14,221.62,255.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.08,254.64a74.37,74.37,0,0,0-11.8,5.49.13.13,0,0,0,.11.24c4-1.7,8-3.34,11.9-5.26A.26.26,0,0,0,266.08,254.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.27,227.42c0-.14-.25-.17-.25,0a132.26,132.26,0,0,1-.67,13.27c-.18,2.05-1.83,13.36-5.38,12.54-.59-.14-.89-.72-1-1.62a14.71,14.71,0,0,1,.47-3.47c.4-2.37.71-4.74.92-7.14a64.35,64.35,0,0,0-.15-13.38.12.12,0,0,0-.23,0,121.37,121.37,0,0,1-1.08,18.48c-.44,2.94-1.92,7.37,1.15,7.83s5.17-7,5.55-9A67.57,67.57,0,0,0,267.27,227.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.07,253.51a19.12,19.12,0,0,0-.8,2.35,5.33,5.33,0,0,0-.33,1.93c0,.12.18.13.24,0A6.61,6.61,0,0,0,261,256c.27-.72.55-1.44.8-2.17A.4.4,0,0,0,261.07,253.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.45,240.73c.14.15,59.38-1.72,59.9-2.34.72-.89-12-59.72-22-72.18-2.52-3.11-11-4-14.33-.5-9.65,10-11.39,17.18-13.7,23.85-1.71,4.93-3.65,13.31-5.35,21.88C222.13,225.56,219.94,240.19,220.45,240.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.09,226.72a6.73,6.73,0,0,1-.25-1.93,6.4,6.4,0,0,1,.25-1.93,7.57,7.57,0,0,1,0,3.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.2,199.6a7.11,7.11,0,0,1-.25-1.93,7.18,7.18,0,0,1,.25-1.94,6.8,6.8,0,0,1,.25,1.94A6.73,6.73,0,0,1,255.2,199.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.61,188.87a6.73,6.73,0,0,1-.25-1.93,6.8,6.8,0,0,1,.25-1.94,6.8,6.8,0,0,1,.25,1.94A7.11,7.11,0,0,1,236.61,188.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86,221.45a7.57,7.57,0,0,1,0-3.86,6.73,6.73,0,0,1,.25,1.93A7.11,7.11,0,0,1,236.86,221.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.75,216.21a7.57,7.57,0,0,1,3.86,0,7.57,7.57,0,0,1-3.86,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,200.18a7.61,7.61,0,0,1,3.87,0,7.61,7.61,0,0,1-3.87,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.27,182a6.73,6.73,0,0,1,1.93-.25,6.36,6.36,0,0,1,1.93.25,7.57,7.57,0,0,1-3.86,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.53,233.53a7.61,7.61,0,0,1,3.87,0,7.61,7.61,0,0,1-3.87,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.12,236.65a7.18,7.18,0,0,1,1.94-.25,7.11,7.11,0,0,1,1.93.25,6.73,6.73,0,0,1-1.93.25A6.8,6.8,0,0,1,259.12,236.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.05,233.53a6.79,6.79,0,0,1-1.55-1.19,7,7,0,0,1-1.19-1.54,6.73,6.73,0,0,1,1.55,1.19A7.27,7.27,0,0,1,251.05,233.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.91,212a7.58,7.58,0,0,1-2.74-2.73,6.79,6.79,0,0,1,1.55,1.19A7,7,0,0,1,230.91,212Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.11,209.67a7.58,7.58,0,0,1-2.73-2.74,7,7,0,0,1,1.54,1.19A6.73,6.73,0,0,1,263.11,209.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.75,190.27a7.58,7.58,0,0,1-2.74-2.73,6.73,6.73,0,0,1,1.55,1.19A7.27,7.27,0,0,1,247.75,190.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.92,234.38a7.58,7.58,0,0,1-2.74-2.73,6.73,6.73,0,0,1,1.55,1.19A7.27,7.27,0,0,1,273.92,234.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,214a7.33,7.33,0,0,1-1.19,1.55,7,7,0,0,1-1.55,1.19A7.5,7.5,0,0,1,274.6,214Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,206.16a7.65,7.65,0,0,1-2.73,2.73,6.67,6.67,0,0,1,1.19-1.54A7,7,0,0,1,246,206.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93,224.94a7.65,7.65,0,0,1-2.73,2.73,7.65,7.65,0,0,1,2.73-2.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.81,191.32a7.65,7.65,0,0,1-2.73,2.73,7.65,7.65,0,0,1,2.73-2.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.63,175.38a7,7,0,0,1-1.19,1.55,7.27,7.27,0,0,1-1.54,1.19,6.79,6.79,0,0,1,1.19-1.55A7,7,0,0,1,244.63,175.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.45,173.67c-2.45.48-8.28-3.37-10.87-7a63.91,63.91,0,0,1-.21-6.53c-.06-2.1-.18-4.42-.45-6.54,0-.44,1.53.18,1.53.18l2.82.32,9.33,1.08a34.05,34.05,0,0,0-.27,8.28,4.51,4.51,0,0,0,.2.86s0,.09,0,.14C258,166.12,259.29,172.91,255.45,173.67Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.53,164.36s0,.09,0,.14a8.51,8.51,0,0,1-1.36.24c-9,.91-11.49-10.31-11.49-10.31l3.55-.29,9.33,1.08a34.05,34.05,0,0,0-.27,8.28A4.51,4.51,0,0,0,257.53,164.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.46,135.72c-1.44,4.75,1.1,18.45,4.48,21.5,4.91,4.42,12.92,4.82,16.66-1.07,3.64-5.71,0-23.5-3.76-26.27C253.27,125.8,243.58,128.71,241.46,135.72Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.57,143.11s-.06.06,0,.1c.24.91.35,2-.4,2.48,0,0,0,.06,0,.05C254.11,145.37,253.94,143.93,253.57,143.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.54,142.34c-1.5.22-.95,3.2.44,3S253.8,142.16,252.54,142.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,141.91s.08,0,.08.07c.14.93.46,2,1.35,2.12,0,0,0,.05,0,.05C259.39,144.2,259,142.82,259,141.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.64,140.8c1.47-.39,2.13,2.56.78,2.92S258.42,141.12,259.64,140.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.11,141.2c.39-.18.72-.41,1.08-.62s.77-.4,1-.85a.63.63,0,0,0-.24-.74,1.61,1.61,0,0,0-1.61.13,2.32,2.32,0,0,0-1.13,1.24A.68.68,0,0,0,251.11,141.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.46,139.44c-.42,0-.82-.05-1.24-.08A2,2,0,0,1,258,139a.65.65,0,0,1-.11-.78,1.59,1.59,0,0,1,1.5-.58,2.26,2.26,0,0,1,1.56.62A.68.68,0,0,1,260.46,139.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,151.83c.26.18.53.44.87.4a2.52,2.52,0,0,0,.95-.41s.06,0,.05,0a1.26,1.26,0,0,1-1.08.71,1,1,0,0,1-.87-.68S254.27,151.81,254.31,151.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.76,148.89a3.21,3.21,0,0,0,2.36,1,3.7,3.7,0,0,0,1.14-.16.73.73,0,0,0,.21-.06l.2-.07a.22.22,0,0,0,.14-.24h0a.29.29,0,0,0,0-.09h0l0-.08c-.11-.71-.38-1.78-.38-1.78.28.08,1.72.43,1.63.07a48.8,48.8,0,0,0-3-9.29.09.09,0,0,0-.17.06c.61,2.95,1.73,5.77,2.39,8.72a5.54,5.54,0,0,0-1.57-.17c-.09,0,.56,2.05.58,2.38,0,0,0,0,0,0a4.41,4.41,0,0,1-3.43-.41C254.76,148.75,254.7,148.83,254.76,148.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.77,149.46a3.74,3.74,0,0,1-1.27,1.43,1.66,1.66,0,0,1-1,.26c-.77-.06-.92-.73-.89-1.34a3.87,3.87,0,0,1,.17-.94A4.93,4.93,0,0,0,257.77,149.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.24,146.09c3.16-.51,2.88-6.34,2.88-6.34s5.29-1.73,5.44-5.94c0,0,5.67,2.49,9.49.39s2.26-6.54,1.66-7.45-2.57,1.25-2.57,1.25-.65-2.55-1.39-2.7-1.24,1.52-1.24,1.52a34.05,34.05,0,0,0-10.2-.07c-4.72.87-6.32,6-6.32,6s-2.45.93-3,2.83S241.23,146.41,243.24,146.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.85,140c4.28-.09,6.64-3.32,6.62-7.43a0,0,0,0,1,.08,0c.46,3.77-2.39,8.48-6.71,7.63A.1.1,0,0,1,244.85,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.09,132.67s.08.05,0,.08c-1.09.72-2.37,1.34-3,2.54-.8,1.45-.32,3.11.28,4.52.93,2.19,2.57,5,4.81,6,.13.06,0,.25-.1.2-2.66-1.06-4.68-4.68-5.43-7.31C236.81,135.74,238.42,133.74,241.09,132.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.34,134.27a6.25,6.25,0,0,0,6.39-1.1c2-1.89,1.11-4.36-.18-6.33-.06-.1.07-.23.16-.14,1.59,1.66,2.14,4.48.58,6.36s-4.85,2.4-7.08,1.49C256,134.47,256.16,134.19,256.34,134.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.41,146.89s-3.19-4.36-5.18-3.21.49,7.52,2.87,8.34a2.4,2.4,0,0,0,3.19-1.36Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,145.48s-.05.06,0,.07a6.1,6.1,0,0,1,3.23,3.72,1.32,1.32,0,0,0-2-.31c-.05,0,0,.09,0,.08a1.48,1.48,0,0,1,1.64.48,7.87,7.87,0,0,1,.81,1.3c.08.14.34.06.28-.11v0C244,148.56,242.26,145.65,240,145.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.75,165.18l-2.4,8.3-10.93-9.1-2.49,3.52s11.32,15.07,11.3,14.34l2.6-7.21,5.23,4.31-1.59-12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.61,173.37c-.33-2-.61-4-1-5.91,0-.07-.13-.09-.13,0-.21,1.95,1.09,9.47,1.26,11.29l0,0c-.22-.19-4.82-3.77-4.86-3.7-.6,1.16-2.51,6.41-2.63,6.88-1.79-2.39-9.31-11.78-11.37-14-.06-.06-.16,0-.11.08,1.62,2.56,11.37,15,11.48,14.92a75.74,75.74,0,0,0,2.71-7.62c.8.81,5.5,4.9,5.48,4.6A61.83,61.83,0,0,0,260.61,173.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.48,173.61c-4.83-5-15.81-23.57-15.57-34.5.18-8.53,4.53-32.07,7.19-38.08,1.2-2.73,19.33,9.06,19.47,12.25s-7,23.11-7.84,28.08c-.4,2.35,1.11,14.43,4.67,25.43C245.61,176.7,240.38,179.68,234.48,173.61Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.77,106c.53-2.61,4-14.33,5.74-17.37s7.24-11.45,9.7-10.39,1,3.66,1,3.66,2.9-3.18,5.28-1.88,0,5.26,0,5.26,3.22-3,5.5-1.58-.75,5-.75,5,2.82-2.92,4.19-.92c1.65,2.41-4.14,7.21-5.77,10.71-.37.8-6.35,16.66-6.35,16.66Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.58,88.39c-4.25,3.54-5.5,5.83-7.18,11,0,.1-.19.08-.16,0,1.18-5.23,2.33-8.32,7.18-11.19C251.65,88,251.78,88.22,251.58,88.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.91,85c-4.09,4.06-5.47,6.53-7.62,11.83,0,.07-.16,0-.14-.05,1.68-5.37,2.9-8.43,7.52-12C246.88,84.62,247.1,84.77,246.91,85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.15,82.12c-3.68,4.23-5.3,6.87-6.73,12.28,0,.13-.23.09-.2,0A18.56,18.56,0,0,1,241,82C241.27,81.8,241.38,81.86,241.15,82.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.3,119.06s5.25-4.81,6.82-7.5,3.7-14.9,1.09-15.51c-3.37-.79-6,6-6.84,9.51,0,0-7.79-1.83-10.73,2.64S244.3,119.06,244.3,119.06Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.21,96.13c-3.59,1.5-4.41,6.16-5.48,9.5a.32.32,0,0,1-.5.17c-3.31-.55-8.15-.36-10.63,2.19a.09.09,0,0,1-.13-.11c2.29-3.08,7-3.66,10.62-2.82,1-3.44,2.08-8.08,6.11-9C251.22,96.09,251.23,96.12,251.21,96.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.65,109.44l23.13,12s-6,16.71-6.5,19.82,5.13,25.14,5.91,29.81-11,21-11.93,12.79-13.38-32.83-14-41.2S221.65,109.44,221.65,109.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,150.8a6.78,6.78,0,0,1-.25-1.93,6.47,6.47,0,0,1,.25-1.94,7.18,7.18,0,0,1,.25,1.94A7.58,7.58,0,0,1,236,150.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.54,124a7.57,7.57,0,0,1,0-3.86,7.57,7.57,0,0,1,0,3.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.22,159.83a7.57,7.57,0,0,1,3.86,0,7.57,7.57,0,0,1-3.86,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.48,134.78a7.18,7.18,0,0,1,1.94-.25,6.73,6.73,0,0,1,1.93.25,6.73,6.73,0,0,1-1.93.25A6.8,6.8,0,0,1,232.48,134.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.57,170.83a7.58,7.58,0,0,1-2.74-2.73,6.79,6.79,0,0,1,1.55,1.19A7,7,0,0,1,236.57,170.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.23,145.79a7.58,7.58,0,0,1-2.74-2.73,6.73,6.73,0,0,1,1.55,1.19A7.27,7.27,0,0,1,228.23,145.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.63,175.38a7,7,0,0,1-1.19,1.55,7.27,7.27,0,0,1-1.54,1.19,6.79,6.79,0,0,1,1.19-1.55A7,7,0,0,1,244.63,175.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.59,157.36a6.67,6.67,0,0,1-1.19,1.54,7,7,0,0,1-1.54,1.19,7.65,7.65,0,0,1,2.73-2.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.07,123.56a7.65,7.65,0,0,1-2.73,2.73,7.65,7.65,0,0,1,2.73-2.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.16,124.78a207.72,207.72,0,0,0-19.8-9.38c-.08,0-.13.09-.05.12,1.65.68,12.22,6.2,19.8,9.4C242.2,125,242.24,124.83,242.16,124.78Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.26,442.45c1.95.65,57.71.49,59.83-.86.81-.5,1.26-8.63,1.52-18.46.06-2.12.1-4.3.14-6.54,0-2.64.08-5.31.09-7.9.07-11.64-.09-21.9-.09-21.9h-36.3l0,21.9v7.9l.18,6.54s-21.31,9.62-23.48,11.35S286.32,441.82,288.26,442.45Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.26,442.45c1.95.65,57.71.49,59.83-.86.81-.5,1.26-8.63,1.52-18.46.06-2.12.1-4.3.14-6.54,0-2.64.08-5.31.09-7.9H313.47v7.9l.18,6.54s-21.31,9.62-23.48,11.35S286.32,441.82,288.26,442.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.09,442.54c1.27.42,25,.5,42.31.14,4-.08,7.66-.19,10.62-.32,4.06-.19,6.79-.41,7.24-.69,1-.63,1.45-12.56,1.67-25.14H313.45l.19,6.58s-21.44,9.66-23.62,11.4S286.14,441.88,288.09,442.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.89,440.29c9.4-.25,47.33-.41,56.64,0,.07,0,.07.06,0,.06-9.31.46-47.24.31-56.64.05C288.69,440.44,288.69,440.3,288.89,440.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.31,421c3.69-.7,8.22-.14,11.05,2.48.11.11,0,.26-.15.22a51.88,51.88,0,0,0-10.89-2.23A.24.24,0,0,1,312.31,421Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.64,422.64c3.7-.7,8.22-.15,11.06,2.48.11.1,0,.26-.16.22a51.66,51.66,0,0,0-10.88-2.23A.24.24,0,0,1,309.64,422.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,424.26c3.69-.7,8.22-.15,11,2.48.11.1,0,.25-.15.22A52.54,52.54,0,0,0,307,424.72.23.23,0,0,1,307,424.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.31,425.87c3.7-.7,8.22-.14,11.06,2.48.11.11,0,.26-.16.22a51.66,51.66,0,0,0-10.88-2.23A.24.24,0,0,1,304.31,425.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.12,417.75c2.63,2,6,2.85,9.09,4a.46.46,0,0,0,.58-.46.1.1,0,0,0,.09-.13,19.8,19.8,0,0,0-5.72-8.46c-1.55-1.29-4.26-2.19-5.71-.18S305.59,416.57,307.12,417.75Zm-.95-3c-.66-4.06,3.7-1.94,4.81-.94a21.76,21.76,0,0,1,2,2.11,57.1,57.1,0,0,1,3.45,4.87c-1.47-.65-3-1.16-4.47-1.75C310.15,418.37,306.54,417,306.17,414.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.21,415.45c-.9-2.3-3.75-2.11-5.57-1.25A19.81,19.81,0,0,0,316,421a.1.1,0,0,0,.05.15c-.06.28.11.63.44.6,3.24-.33,6.75-.27,9.79-1.58C328.05,419.37,330.06,417.63,329.21,415.45Zm-7.91,4.76c-1.59.2-3.18.32-4.77.58a57.64,57.64,0,0,1,4.56-3.85,21.34,21.34,0,0,1,2.43-1.56c1.32-.69,6.07-1.65,4.42,2.11C327,419.56,323.19,420,321.3,420.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.86,232.11s-9.81,97-10.05,98.26c0,.16-.1,2-.19,5.07-.53,16.7-1.84,68.78-1.84,68.78h-40s2.61-61.68,4.11-76.07c1.91-18.36,14-96,14-96Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,333.79q1.86-31.55,5.57-62.92c1.4-11.79,3.1-23.54,4.78-35.29,0-.1.17-.1.16,0-3.1,20.92-5.29,42-7.18,63s-3.21,42.11-4.07,63.2c-.49,12-.86,23.91-1.24,35.87a.23.23,0,0,1-.45,0C345.18,376.38,345.79,355.07,347,333.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.29,397.77c1-.13,2.18-.09,3.25-.13s2.4-.05,3.6-.1q3.48-.12,7-.18,7-.12,14,.1l3.86.13c1.37.06,2.74.18,4.11.17a.07.07,0,1,1,0,.13c-2.36,0-4.74.2-7.09.29s-4.64.12-6.95.15c-4.67.07-9.36,0-14-.15l-3.86-.1-2.05-.09c-.61,0-1.22,0-1.83-.06C312.17,397.92,312.18,397.79,312.29,397.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.86,232.11s-9.81,97-10.05,98.26c0,.16-.1,2-.19,5.07L332.75,232.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.15,411c1.72-1.14,36.05-45.07,36.3-47.57.1-1-6-6.32-13.57-12.6-1.63-1.37-3.27-2.84-5.06-4.16-2.24-1.67-4.51-3.31-6.72-4.86-9.56-6.78-17.86-12.1-17.86-12.1l-21.8,27.73,17,12.58,7,5.16,5.26,3.9s-5.62,22.7-5.6,25.47S435.44,412.11,437.15,411Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.15,411c1.72-1.14,36.05-45.07,36.3-47.57.1-1-6-6.32-13.57-12.6-1.63-1.37-3.27-2.84-5.06-4.16-2.24-1.67-4.51-3.31-6.72-4.86-6.76,8.51-16.55,20.66-22.67,28.21l7,5.16,5.26,3.9s-5.62,22.7-5.6,25.47S435.44,412.11,437.15,411Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.11,411.16c1.72-1.14,36.25-45.32,36.5-47.84.12-1.16-9-8.89-18.73-16.85l-22.55,28.67,5.29,3.92S432,401.89,432,404.68,435.38,412.3,437.11,411.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.83,409.14c5.61-7.55,28.93-37.46,35.05-44.49.05-.06.09,0,0,0-5.39,7.6-28.95,37.32-35,44.55C435.83,409.39,435.72,409.3,435.83,409.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.16,378.82c1.73-3.34,5-6.55,8.78-7.16.15,0,.18.19.08.26a51.49,51.49,0,0,0-8.48,7.18A.24.24,0,0,1,435.16,378.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.78,381.92c1.74-3.34,5-6.56,8.79-7.16.14,0,.18.19.07.26a51.77,51.77,0,0,0-8.48,7.17A.24.24,0,0,1,434.78,381.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.41,385c1.73-3.34,5-6.55,8.78-7.16.15,0,.18.19.08.26a52,52,0,0,0-8.49,7.18A.23.23,0,0,1,434.41,385Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,388.1c1.73-3.33,5-6.55,8.78-7.15.15,0,.18.18.08.26a51.77,51.77,0,0,0-8.48,7.17A.24.24,0,0,1,434,388.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.38,380.87c3.22-.8,6-3,8.74-4.68a.46.46,0,0,0,0-.75.1.1,0,0,0-.05-.15,19.77,19.77,0,0,0-10.18-.73c-2,.42-4.35,2-3.67,4.38S427.51,381.35,429.38,380.87Zm-2.92-1.09c-3.6-2,.76-4.1,2.23-4.35a21.24,21.24,0,0,1,2.88-.24,59.11,59.11,0,0,1,5.95.29c-1.41.76-2.75,1.63-4.13,2.44C431.74,378.88,428.44,380.88,426.46,379.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.23,362.09c-2.37-.71-4,1.64-4.43,3.61a19.7,19.7,0,0,0,.59,10.19c0,.08.09.08.15.05a.45.45,0,0,0,.74,0c1.75-2.75,4-5.47,4.81-8.67C443.59,365.42,443.47,362.77,441.23,362.09Zm-1.15,9.16c-.83,1.38-1.72,2.7-2.49,4.1a59.25,59.25,0,0,1-.22-6,21.3,21.3,0,0,1,.29-2.87c.27-1.46,2.45-5.79,4.38-2.17C443.11,366.35,441.06,369.62,440.08,371.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.34,231.57s3.12,14.56,12.9,21.68c0,0,25.16,66.05,30.45,73,8.76,11.52,51.14,41.17,51.14,41.17l25-31.87s-41-26.39-44.28-30.54c-2.19-2.75-19.65-45.16-19.44-46.67,2.4-17.93-6.15-29.07-6.15-29.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,232.06a42.68,42.68,0,0,1,4.21,11A34.82,34.82,0,0,1,379,249c.12,2.13,0,4.27,0,6.41a23.41,23.41,0,0,0,1,6.44c.6,2,1.33,4,2,6q2.16,6.14,4.55,12.19,4.77,12,10.37,23.74a18.17,18.17,0,0,0,3.19,5,30.24,30.24,0,0,0,5,3.72q5.52,3.76,11.05,7.52l22.21,15.11v.05c.25.17,0,.58-.23.41-7.44-5.05-12.14-8.27-19.58-13.32l-11.27-7.65c-1.78-1.21-3.59-2.38-5.33-3.63a14.17,14.17,0,0,1-3.87-4,49.45,49.45,0,0,1-2.72-5.33c-.94-2-1.86-4-2.76-6Q389.94,290,387.51,284t-4.69-12.14q-1.12-3.08-2.19-6.18a45.39,45.39,0,0,1-1.8-6c-.83-4.2-.09-8.51-.49-12.75a38.88,38.88,0,0,0-3-11.91,30.93,30.93,0,0,0-1.46-2.87C373.81,232.06,374,232,374,232.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.23,233.2a13.39,13.39,0,0,0,4.9,7,16.59,16.59,0,0,0,8.89,3.05c.54,0,.59.85,0,.86-6.53,0-13.12-4.14-14.08-10.9C359.94,233.08,360.19,233.05,360.23,233.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,248.81a36.57,36.57,0,0,1,6.74,3.58c2.24,1.39,4.31,3,6.47,4.51.09.06,0,.19-.07.14-2.27-1.31-4.63-2.44-6.88-3.79a42.51,42.51,0,0,1-6.36-4.26C333.81,248.93,333.88,248.78,334,248.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.06,235.21c.35,1.49.78,3,1.18,4.45s.66,2.82,1.09,4.19a7.32,7.32,0,0,0,2.14,3.46c.57.49,1.2.91,1.81,1.36l1,.7c-.05-.19-.09-.4-.14-.6-.13-.57-.25-1.13-.37-1.7-.27-1.26-.53-2.52-.79-3.79-.49-2.48-1-5-1.59-7.45a.08.08,0,1,1,.15,0c.73,2.42,1.53,4.82,2.19,7.27.32,1.2,1.54,7.15,1.61,7.57s.12.88.15,1.32a5,5,0,0,1,.06,1.34.11.11,0,0,1-.2,0h0a5.53,5.53,0,0,1-.44-1.28c-.13-.42-.24-.85-.34-1.29l-.09-.47c-.61-.33-1.18-.78-1.75-1.16s-1.24-.79-1.82-1.24a6.77,6.77,0,0,1-2.31-3.26,24.14,24.14,0,0,1-.9-4.28c-.27-1.69-.49-3.4-.8-5.08C332.89,235.16,333,235.11,333.06,235.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.83,361.65c.54-.91,1.29-1.78,1.92-2.63s1.45-1.92,2.16-2.89q2.05-2.81,4.17-5.57c2.84-3.71,5.77-7.37,8.78-10.94l2.5-2.94c.89-1,1.84-2,2.69-3.12.06-.08.15,0,.09.08-1.47,1.84-2.78,3.84-4.17,5.74s-2.78,3.71-4.19,5.55c-2.85,3.7-5.79,7.35-8.82,10.91-.84,1-1.65,2-2.48,3-.44.52-.9,1-1.34,1.55s-.75,1-1.19,1.4A.08.08,0,0,1,417.83,361.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.85,184.15a.46.46,0,0,0,.42.45l1.84-.13c1.08-4.79,2.39-8.67,2.11-7.19a25.37,25.37,0,0,0-.3,7.06l3.63-.32c.43-8.24,1.52-14.46,1.63-12.61.45,7.49,1.16,9.82,1.95,12.3,8.75-.79,20.21-2,28.48-3,.41-4.58.66-9.51.84-9.2,1.43,2.36,2.19,6,2.56,8.76,2.63-.35,4.72-.68,6-1,0,0,.16-3.83.1-5.07A27.9,27.9,0,0,0,353,165a47.44,47.44,0,0,0-4.89-8.15l0-.06s0,0,0,0a26.91,26.91,0,0,1-2.91-5.49.05.05,0,0,1,0,0,28.22,28.22,0,0,1-1.23-4.36c-1.05-5.44-4.52-9.78-9.51-10.56-10.21-7.9-18.84-2.76-20.72,4.67-.19.72-.35,1.55-.49,2.44v0c-.55,3.3-.87,7.54-1.25,10.83v0a0,0,0,0,1,0,0h0a32,32,0,0,1-.63,3.83C309.73,164.24,304.88,168.23,305.85,184.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.7,137.55a10.19,10.19,0,0,1,6.61,7.57,28.39,28.39,0,0,0,2.1,6.64,24.29,24.29,0,0,0,4.37,5.5,18.14,18.14,0,0,1,5.35,9.27,32.56,32.56,0,0,1,.44,12.58s0,0,0,0a34.51,34.51,0,0,0-1.18-13c-1.22-4.25-3.85-6.67-6.6-9.64a18.58,18.58,0,0,1-4.54-8.39c-.48-2-.71-4-1.68-5.78a11.24,11.24,0,0,0-5-4.28C336.27,137.85,336.45,137.45,336.7,137.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.78,165.08c1.85-3.43,3.84-6.41,4.67-10.45.76-3.69,1-7.51,1.76-11.19,0-.06.1-.05.09,0-1.1,6.51-.69,12.86-3.81,18.64-1.69,3.13-3.41,6.06-4.33,9.67a32.66,32.66,0,0,0-.73,11.59c0,.14-.16.16-.18,0A27,27,0,0,1,306.78,165.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.06,183.12c-10.3,1.82-45.06-9.17-51.57-16.31-9.69-10.61-17.05-29.56-19.14-36.69-.91-3.11,19.57-12.47,21-9.33,3.12,6.73,12,27.6,13.73,29.56s19,13.93,29,19.23C338.57,176.71,337.27,182.2,332.06,183.12Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.87,125.14c-.16-1.54-4.92-13.07-7.56-16.76A44,44,0,0,0,266.43,98c-6.08-4.54-10.72-7.12-11.92-6.21-2.22,1.68-.9,4.41,5.19,9.08s5.27,9.2,4.45,12.36a47.7,47.7,0,0,0-.13,23.65S284.51,131.09,283.87,125.14Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.48,112.09c-.74,3.29-4.83-9-8.52-10s-3.39,2.85-2,6.23c4.91,11.7,2.75,19.12,8.52,25.84S264.48,112.09,264.48,112.09Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.9,138.92c.44-.37,23.33-13.63,23.33-13.63s8.5,21.67,10.24,24.26,26.76,18.56,35.41,23.61c9.25,5.41,6.49,13.38-9.8,10.16s-34.89-9.49-41.07-14.87C275,163.24,262.9,138.92,262.9,138.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,141.45c9.41-4.4,18.64-10.46,20.32-11.4.08-.05,0-.17-.08-.12-1.6,1-12.89,6.79-20.33,11.39A.08.08,0,0,0,266.33,141.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.67,214.13l1.7,28.24s44.81-8.6,55.74-11.68c0,0-19.67-49.38-34.28-59.86-7.31-5.24-14.21-3.3-17.73,2.15-.9,1.38-10.68,22-10.69,29.08C316.42,208.32,321.67,214.13,321.67,214.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.36,171.35c-.22.89-4.57,6.66-8.67,6.42-1.34-.08-1.22-7.38-1.22-7.38l-.11-.55-1.6-7.57,8.95-5.58L336,156s.3,2.1.65,4.72c0,.12,0,.24.05.37l.06.43c.06.39.11.79.16,1.19s.08.6.1.92.07.63.11.95A51,51,0,0,1,337.36,171.35Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.65,160.67a15.53,15.53,0,0,1-9.29,9.17l-1.6-7.57,8.95-5.58L336,156S336.3,158.05,336.65,160.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.7,152.13c.51,13.58,8.7,14.81,11.63,14.7,2.65-.11,11.69-.79,12.59-14.35s-5.57-17.61-11.67-17.7S314.2,138.56,314.7,152.13Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.57,148.31a9.32,9.32,0,0,0,.91-.23,1.51,1.51,0,0,0,.88-.41.47.47,0,0,0,0-.59,1.21,1.21,0,0,0-1.19-.24,1.75,1.75,0,0,0-1.08.67A.52.52,0,0,0,316.57,148.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.49,148a7.54,7.54,0,0,1-.93-.16,1.5,1.5,0,0,1-.91-.34.5.5,0,0,1,0-.59,1.19,1.19,0,0,1,1.17-.32,1.71,1.71,0,0,1,1.13.58A.51.51,0,0,1,325.49,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.8,151.52s.08,0,.08.08c0,.93.12,2,1,2.29,0,0,0,.05,0,.05C323.81,153.81,323.64,152.4,323.8,151.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.62,150.55c1.48-.14,1.64,2.85.26,3S323.37,150.66,324.62,150.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.21,150.67c.27.16.54.44.86.46s.62-.31.84-.62c0,0,0,0,.06,0,0,.57-.16,1.17-.76,1.28s-1-.38-1.16-.94C325,150.77,325.1,150.61,325.21,150.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.48,151.62s-.07,0-.06.09c.08.92,0,2-.79,2.35,0,0,0,.06,0,.05C318.65,153.91,318.71,152.48,318.48,151.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.6,150.71c-1.49,0-1.43,3-.05,3S318.85,150.73,317.6,150.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,150.92c-.23.16-.46.46-.74.48s-.57-.29-.79-.6c0,0,0,0,0,0,0,.57.19,1.16.74,1.26s.86-.41,1-1C317.16,151,317.08,150.85,317,150.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.27,158.87c-.2.24-.39.56-.72.62a2.47,2.47,0,0,1-1-.13,0,0,0,0,0,0,0,1.24,1.24,0,0,0,1.22.38,1,1,0,0,0,.64-.88C324.37,158.85,324.3,158.84,324.27,158.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.27,155.69a20.22,20.22,0,0,0-.11,2c0,.06.16.08.38.09h0a3.1,3.1,0,0,0,3-1.28.07.07,0,0,0-.1-.09,4.66,4.66,0,0,1-2.8.93c-.05-.18.31-2.37.21-2.38a5.82,5.82,0,0,0-1.46.4c.19-2.9.85-5.75,1-8.64a.09.09,0,0,0-.18,0,47.17,47.17,0,0,0-1.48,9.25C318.69,156.35,320,155.81,320.27,155.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.54,157.38a3.73,3.73,0,0,0,1.43,1.26,1.67,1.67,0,0,0,1,.14c.76-.15.82-.83.73-1.42a4,4,0,0,0-.28-.92A4.92,4.92,0,0,1,320.54,157.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,158.64a1.67,1.67,0,0,0,1,.14c.76-.15.82-.83.73-1.42A1.75,1.75,0,0,0,322,158.64Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.37,152.07c-3.29.18-3.5-5-3.5-5s-3.75-.16-4.3-6.17a9.1,9.1,0,0,1-6.64,4.69c-1.07.21,2.39-2.73,2.39-2.73s-4.11,4.09-12.16,3c-.57-.08-.41-9.33,5.72-12.49s12.49-1,16.54,2.76c0,0,4.68,1.91,5.4,6.22S339.64,152,338.37,152.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.8,153.61s2.42-4.58,4.46-3.77.59,7.19-1.55,8.3a2.29,2.29,0,0,1-3.21-.84Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.8,151.66s.05,0,0,.06a5.77,5.77,0,0,0-2.53,4,1.27,1.27,0,0,1,1.84-.58s0,.09,0,.09a1.41,1.41,0,0,0-1.48.68,7,7,0,0,0-.58,1.34c-.06.15-.32.1-.29-.06v0C337.46,155.13,338.67,152.13,340.8,151.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.39,176.11c17.25,18.17,31.42,56,23.12,59.51-7.58,3.24-31.61.24-41.49-2.11-2.9-.7,3-23.18,6.05-22.44,3.75.89,13.34,2.27,13.73,2.24.83-.06-8-25.21-10.84-34.86C335,165,341.92,169.29,348.39,176.11Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.17,205.9a3.56,3.56,0,0,0,.3,4,5.25,5.25,0,0,0-2.52,2.54c-.83,2,2,4.18,2,4.18a6.51,6.51,0,0,0-2.24,3.11c-.59,2,1.92,4.59,1.92,4.59a5.73,5.73,0,0,0-.25,4c1.2,3.45,6.66,4.69,10.12,5.52s14-.08,16.07-.05L337,211.67s-14.45-8.1-18.66-8.49C314.81,202.85,307.68,203.57,306.17,205.9Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.71,209.63c3.85-.55,7.65.06,11.48.46a.07.07,0,0,1,0,.13c-3.81-.44-7.65-.12-11.46-.41A.09.09,0,0,1,306.71,209.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.06,216.4a10.21,10.21,0,0,1,2.64.22c.93.15,1.86.31,2.78.48,1.85.35,3.69.74,5.51,1.19.09,0,.08.14,0,.13q-2.76-.53-5.55-.93l-2.78-.38a12.18,12.18,0,0,1-2.62-.45A.14.14,0,0,1,306.06,216.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.67,224.39a6.87,6.87,0,0,1,2.37.33l2.52.51c1.68.33,3.36.67,5.05.94.09,0,.07.15,0,.14-1.72-.28-3.45-.52-5.16-.81l-2.53-.43a6.69,6.69,0,0,1-2.26-.6S305.64,224.39,305.67,224.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.91,212.59c1.19-1-8.23-24.69-10.8-35.47s2.41-10.18,10.3-1.5c8.46,9.3,22.52,29.87,25.72,51.06,1,6.62,2.35,11.34-13,11.07a174.37,174.37,0,0,1-26.57-2.32l3.34-24.2S348.57,212.88,348.91,212.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,235.24c2-9.58,2.56-19.94,2.8-21.74,0-.08-.13-.09-.14,0-.14,1.77-2.11,13.54-2.81,21.73C339.85,235.32,340,235.33,340,235.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.55,214.47a20,20,0,0,0-2.89-.59l-2.69-.49-1.17-.21h.11l1.56-.22c.52-.08,1-.19,1.57-.24.08,0,.08-.14,0-.13-.52.07-1,.07-1.56.1l-1.63.11-1.42.15c-.87-.14-1.74-.28-2.61-.4-.38-1.72-1-3.42-1.51-5.1s-1.12-3.5-1.72-5.24-1.21-3.4-1.87-5.08c-.33-.84-2.09-6-2.67-7.36,0-.09-.14,0-.12.05.34,1.36,2.14,6.67,2.4,7.53.19.63.39,1.26.59,1.88l-.08-.09-1.05-1.4c-.7-.95-1.4-1.91-2-2.92,0-.09-.18,0-.13.08.58,1.06,1.13,2.12,1.74,3.15.31.52.63,1,1,1.52a7.69,7.69,0,0,0,1.08,1.4h0c.16.51.31,1,.48,1.54.54,1.72,1.09,3.44,1.62,5.16s.92,3.2,1.48,4.75c-1.79-.24-3.57-.45-5.36-.67l-2.74-.32c-1-.11-2-.11-3-.28-.09,0-.12.12,0,.13,1,.11,1.94.41,2.9.58l2.7.47c1.9.32,3.81.66,5.72,1s3.78.5,5.67.72l2.85.32a19.78,19.78,0,0,0,2.77.23A0,0,0,0,0,360.55,214.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.77,237.77c-8.25-.29-23.1-1.42-30-2.34a.07.07,0,1,0,0,.13,118.4,118.4,0,0,0,30,2.53A.16.16,0,0,0,364.77,237.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.45,209c-.45-1-.93-2-1.39-3-.54-1.16-.59-1-.1.3s.91,2.43,1.38,3.64c.92,2.41,5.69,17,5.16,22.16,0,.07.11.08.12,0C375.85,225.21,371.12,212.77,369.45,209Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.6,142.85c11.34,11,13.65,39.31-.33,58.35-11.84,16.12-39.33,19.19-51.15,9.58-12.53-10.21-10.69-26.75-1.53-34.8,9.45-8.3,20.79-6.07,26.52-13.47,2.74-3.54,3.76-11,7.58-16.45C152,140,160.8,137.2,166.6,142.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.18,140.76c1.26-.47,2.45-7.49-2.16-10.83s-10.52.48-8,6.23C147.55,139.79,153.53,141.75,156.18,140.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,151.11a48.45,48.45,0,0,1-3.11,7.45,19.07,19.07,0,0,1-5.15,6.3,12.41,12.41,0,0,1-3.74,1.76c-1.3.42-2.6.77-3.89,1.13a78.7,78.7,0,0,0-7.63,2.42,31,31,0,0,0-7,3.64,19.23,19.23,0,0,0-8,13.14,34,34,0,0,0-.23,8,31.58,31.58,0,0,1-.25-8.07,20.12,20.12,0,0,1,2.46-7.74,19.12,19.12,0,0,1,5.47-6.06,32.16,32.16,0,0,1,7.2-3.84,76.79,76.79,0,0,1,7.75-2.37c1.3-.35,2.59-.69,3.86-1.08a13.26,13.26,0,0,0,3.56-1.57,18.28,18.28,0,0,0,5.16-5.91A55.3,55.3,0,0,0,145,151.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.77,145.31a56.39,56.39,0,0,1,7.53,15.55,46.48,46.48,0,0,1,2,17.23,36.23,36.23,0,0,1-1.77,8.55c-.21.7-.49,1.37-.76,2.05s-.53,1.36-.87,2-.63,1.32-1,2l-1.13,1.87a44.85,44.85,0,0,1-12,12.39c1.07-1,2.2-1.85,3.23-2.85s2.09-2,3-3.08a41.59,41.59,0,0,0,5.11-6.86A36.83,36.83,0,0,0,177.33,178a47.07,47.07,0,0,0-1.77-16.92,63.38,63.38,0,0,0-2.87-8.1A60.2,60.2,0,0,0,168.77,145.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57,129.52a7.9,7.9,0,0,0-2.66,4.44,4.75,4.75,0,0,0,1.4,4.52,9.54,9.54,0,0,0,4.59,2.25,15.37,15.37,0,0,0,2.63.32,7.21,7.21,0,0,0,2.65-.29,6.48,6.48,0,0,1-2.63.78,11.84,11.84,0,0,1-2.79,0,9.25,9.25,0,0,1-5.14-2.28,5.25,5.25,0,0,1-1.46-5.42A6.9,6.9,0,0,1,147.57,129.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,177.73c-3.55,23.33-24.13,70.83-27.24,76.93-2.11,4.14-24.23-6.53-22.37-9.12,2.37-3.33,26.15-45.06,37.49-60.16C148.28,177.05,154.87,172.91,154.14,177.73Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,244.88c-2.58,3.4-6.62,13.11-7.55,16.35S94.54,274,97,275s3.21-1.78,3.21-1.78-.2,4.15,2.31,4.9,3.63-3.56,3.63-3.56.1,4.28,2.66,4.84,3-4,3-4-.09,3.92,2.21,3.5c2.78-.51,2.12-7.75,3.41-11.25.3-.8,7.09-15.69,7.09-15.69Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.26,275.53c-.47-5.32.25-7.73,2.66-12.41,0-.09-.08-.18-.14-.09-2.77,4.36-4.11,7.26-2.78,12.54C111.07,275.83,111.28,275.79,111.26,275.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.73,274.68c0-5.58.75-8.2,2.91-13.29,0-.07-.08-.13-.12-.06-2.54,4.81-3.81,7.73-3.07,13.3C105.48,274.88,105.73,274.93,105.73,274.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.87,272.66c.38-5.4,1.09-8.31,3.82-13a.1.1,0,0,0-.16-.11,17.94,17.94,0,0,0-3.83,13.06C99.73,273,99.84,273,99.87,272.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.32,250.1s-.3,6.69-1.09,9.6-7.68,12.68-9.88,11.31c-2.83-1.77,0-8.2,1.86-11.16,0,0-6.56-4.09-5.49-9.15S128.32,250.1,128.32,250.1Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.73,270.27c-1.42-3.48,1.22-7.22,2.77-10.23a.31.31,0,0,0-.22-.46c-2.63-1.9-5.8-5.34-5.74-8.77a.08.08,0,0,0-.16,0c-.56,3.66,2.28,7.3,5.3,9.2-1.64,3.06-4.12,6.92-2,10.28C116.71,270.3,116.74,270.29,116.73,270.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,203.82s3.36,1.73,7.26,3.79c5.1,2.67,11.13,5.89,11.77,6.44,0,0,6.53-21.05,8-30.46s.11-11.25-6.75-5.58c-3.31,2.75-8.15,8.86-12.26,14.45C130.78,198.44,127.19,203.82,127.19,203.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,203.82s3.36,1.73,7.26,3.79c5.1,2.67,11.13,5.89,11.77,6.44,0,0,6.53-21.05,8-30.46s.11-11.25-6.75-5.58c-3.31,2.75-8.15,8.86-12.26,14.45C130.78,198.44,127.19,203.82,127.19,203.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.2,183.59c-1.45,9.41-8,30.46-8,30.46-.64-.55-6.67-3.77-11.77-6.44l-2.82-1.48c-2.57-1.35-4.44-2.31-4.44-2.31s3.59-5.38,8-11.36c4.11-5.59,8.95-11.7,12.26-14.45l.72-.58C154.4,172.48,155.6,174.52,154.2,183.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.2,183.59c-1.45,9.41-8,30.46-8,30.46-.64-.55-6.67-3.77-11.77-6.44l-2.82-1.48c-2.57-1.35-4.44-2.31-4.44-2.31s3.59-5.38,8-11.36c4.11-5.59,8.95-11.7,12.26-14.45l.72-.58C154.4,172.48,155.6,174.52,154.2,183.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.2,183.59c-1.45,9.41-8,30.46-8,30.46-.64-.55-6.67-3.77-11.77-6.44l-2.82-1.48c4.05-7.13,11.64-20.24,16.54-28.7C154.4,172.48,155.6,174.52,154.2,183.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.07,209.35a182.22,182.22,0,0,0-17.23-8.72c-.07,0-.11.08,0,.11,1.43.64,10.62,5.74,17.22,8.73C147.09,209.5,147.14,209.39,147.07,209.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.73,173c.15.9,4.05,6.95,8.14,7,1.33,0,1.74-7.24,1.74-7.24l.16-.53,2.14-7.41-8.47-6.2-1.23-.83s-.45,2.07-1,4.64c0,.12-.05.24-.07.37s-.07.28-.1.42c-.08.38-.17.78-.25,1.17s-.12.59-.17.9-.11.62-.17.94A49.31,49.31,0,0,0,154.73,173Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.22,162.41a15.48,15.48,0,0,0,8.55,9.8l2.14-7.41-8.47-6.2-1.23-.83S156.76,159.84,156.22,162.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.68,151.88c3.14,13.15-4.32,16.64-7.23,17.19-2.6.5-11.42,2.37-15.9-10.39s.64-18.38,6.45-20.09S173.54,138.72,176.68,151.88Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35,149.19c-.32,0-.62,0-.94,0a1.55,1.55,0,0,1-.94-.22.47.47,0,0,1-.09-.58,1.17,1.17,0,0,1,1.11-.47,1.73,1.73,0,0,1,1.19.43A.52.52,0,0,1,175.35,149.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.81,151.09a8.26,8.26,0,0,0,.87-.34,1.49,1.49,0,0,0,.82-.52.49.49,0,0,0-.1-.58,1.2,1.2,0,0,0-1.2-.08,1.8,1.8,0,0,0-1,.79A.52.52,0,0,0,166.81,151.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.32,154.05s-.06,0,0,.09c.2.9.28,2-.49,2.42,0,0,0,.06,0,.05C169.77,156.28,169.65,154.87,169.32,154.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.33,153.26c-1.47.16-1,3.1.34,3S169.57,153.12,168.33,153.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.78,153.5c-.23.2-.44.53-.75.61s-.66-.18-.94-.44c0,0-.05,0-.05,0,.08.57.38,1.11,1,1.11s.88-.57.94-1.15C168,153.56,167.87,153.42,167.78,153.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.14,152.81s.08,0,.08.07c.1.91.37,2,1.24,2.13,0,0,0,.05,0,.05C174.43,155.06,174.09,153.69,174.14,152.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.82,151.74c1.45-.32,2,2.6.64,2.9S173.6,152,174.82,151.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.46,151.82c.26.11.54.35.82.32s.51-.4.65-.74c0,0,0,0,.06,0,.11.55,0,1.17-.48,1.38s-.92-.23-1.16-.76C175.31,152,175.36,151.77,175.46,151.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.36,161.08c.24.19.49.47.83.46a2.55,2.55,0,0,0,1-.33s.06,0,0,0a1.23,1.23,0,0,1-1.11.62,1,1,0,0,1-.8-.74S170.32,161.05,170.36,161.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.63,157.18s.41,1.33.51,2c0,.06-.14.11-.36.16h0a3.08,3.08,0,0,1-3.14-.65.07.07,0,0,1,.08-.11,4.71,4.71,0,0,0,2.91.35c0-.19-.78-2.25-.68-2.28a5.69,5.69,0,0,1,1.51.1c-.77-2.79-2-5.44-2.7-8.22,0-.1.12-.16.16-.07a47.25,47.25,0,0,1,3.29,8.73C175.3,157.52,173.9,157.25,173.63,157.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.65,158.83a3.76,3.76,0,0,1-1.13,1.53,1.66,1.66,0,0,1-1,.34c-.77,0-1-.64-1-1.24a3.66,3.66,0,0,1,.08-1A4.85,4.85,0,0,0,173.65,158.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.52,160.36a1.66,1.66,0,0,1-1,.34c-.77,0-1-.64-1-1.24A1.77,1.77,0,0,1,172.52,160.36Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.77,158.24c1.45-.29,4.7-4.86,3.81-11.94,0,0,.36,6.41,0,7.41s1.81-2.57,1.18-8.29a23.49,23.49,0,0,0,6.28,2.21c2.79.37,4.44.11,4.6-.11s-4-.91-5.22-2c0,0,7.63,2.31,11,2.1.39,0-.27-7.94-5.84-10.55s-13.15,2.13-15,4.53c0,0-2.5.73-4.74,4.89S152.21,158.56,153.77,158.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,158.88s-3.54-3.75-5.28-2.42,1.36,7,3.71,7.54a2.29,2.29,0,0,0,2.85-1.66Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,158.08s0,0,0,.06a5.79,5.79,0,0,1,3.49,3.14,1.27,1.27,0,0,0-1.92-.07,0,0,0,0,0,.05.08,1.42,1.42,0,0,1,1.61.26,6.26,6.26,0,0,1,.91,1.13c.1.13.34,0,.26-.14l0,0C155.82,160.51,153.86,158,151.69,158.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.19,382.48c.39-.19,55.21-27.21,64.28-44.21,16.21-30.4,21.85-69.26,23.89-78.39a134.51,134.51,0,0,0,8.49-32.76s-44.18,0-44.18,0-11.59,22.17-5.61,37.83c.54,1.44-9.83,50.65-14.9,56.48-5.64,6.47-48.89,28.18-49.62,28.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.23,232.74c-2.18,11.16-4.66,22.27-7.16,33.36s-5.13,22-7.9,32.93q-2.1,8.28-4.32,16.51c-1.35,5-2.67,10.12-6.07,14.15s-7.74,6.8-11.9,9.68c-4.4,3-8.92,5.91-13.52,8.64-9.28,5.52-18.85,10.53-28.46,15.44l-3.53,1.79c-.26.13,0,.52.24.39,9.74-4.84,19.46-9.78,28.88-15.22q7.07-4.07,13.88-8.54c2.23-1.47,4.43-3,6.61-4.54a69.26,69.26,0,0,0,5.91-4.6,23.62,23.62,0,0,0,4.7-5.65,32.33,32.33,0,0,0,2.84-6.95c1.61-5.31,2.95-10.72,4.34-16.09q4.32-16.65,8-33.44c2.49-11.19,4.8-22.42,6.81-33.71.25-1.37.49-2.74.75-4.11C156.39,232.68,156.24,232.64,156.23,232.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.85,227.12a134.51,134.51,0,0,1-8.49,32.76c-.21.92-.45,2.14-.73,3.63-.07.36-.14.73-.22,1.11s-.19,1-.3,1.57-.19,1-.29,1.54l-.21,1.07c-.13.71-.28,1.46-.43,2.23-.06.31-.12.63-.19.94-.11.59-.24,1.2-.36,1.82-.51,2.5-1.08,5.23-1.72,8.14-.28,1.23-.57,2.51-.88,3.81s-.62,2.63-1,4c-.14.58-.29,1.16-.44,1.74-.76,3-1.61,6.19-2.54,9.4-.2.71-.41,1.42-.62,2.14q-1.42,4.75-3.08,9.64c-.28.81-.57,1.62-.85,2.44q-.87,2.43-1.81,4.88l-16.36-92.86C147,227.1,176.86,227.1,176.85,227.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.33,357.85c-2,1-3.9,2.08-5.76,3.1l-3.38,1.87c-7,3.9-12.28,7.08-12.35,7.9-.23,2.5,25.05,52.19,26.51,53.64S58,421.72,58.58,419c.33-1.65,0-10.93-.26-17.95a0,0,0,0,1,0,0c-.2-4.51-.37-8.09-.37-8.09l5.9-2.82,26.91-12.81-17-33.19S60.08,351,47.33,357.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.61,382.89c-.68-.92-18.53-36.18-18.53-36.18s-39.72,20.6-40.74,23.75S51.84,425.52,53,426.05s5.72-3,7.06-8.37c1-3.9-.27-23.24-.27-23.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2,395.85c-.09-3.74-1.57-8-4.72-10.23-.12-.08-.24.09-.18.2a52.1,52.1,0,0,1,4.45,10.11A.23.23,0,0,0,62.2,395.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.92,394.46c-.09-3.74-1.58-8-4.73-10.23-.12-.08-.24.09-.18.2a50.92,50.92,0,0,1,4.45,10.11A.24.24,0,0,0,64.92,394.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.63,393.07c-.09-3.74-1.58-8-4.72-10.23-.12-.08-.24.09-.18.2a51.47,51.47,0,0,1,4.44,10.11A.24.24,0,0,0,67.63,393.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.35,391.68c-.1-3.74-1.58-8-4.73-10.23-.12-.09-.24.09-.18.2a52.1,52.1,0,0,1,4.45,10.11A.24.24,0,0,0,70.35,391.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.06,390.29c-.09-3.74-1.58-8-4.72-10.23-.13-.09-.25.09-.18.2a51.47,51.47,0,0,1,4.44,10.11A.24.24,0,0,0,73.06,390.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.52,266.65s3.78,35.84,5.54,53.88c.45,4.49.75,7.89.86,9.34,0,.58.06,9.94.08,22.19,0,10.74,0,23.68,0,34.83v8c0,10.28,0,17.6,0,17.6h36.43s0-.34,0-1c0-.34,0-.76,0-1.26s0-1.1,0-1.78c0-.39,0-.82,0-1.26,0-3.07.11-7.32.18-12.27,0-2.54.07-5.25.11-8.09.28-22.06.51-51.69-.12-60.42-.08-1-.15-2.05-.22-3.12-1.64-24.71-2.55-60.68-14.67-96.23H132.61s.4,20.88,9.9,36A78.54,78.54,0,0,1,150.52,266.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.82,337.7c-.18-11.52-.65-23-1.55-34.52s-2.28-22.68-4.12-33.94a281,281,0,0,0-7.35-33.57c-.4-1.38-.81-2.76-1.23-4.13a.15.15,0,0,0-.29.08c2.95,11,5.49,22.17,7.42,33.44s3.2,22.74,4.16,34.18,1.5,23,1.79,34.49.31,23,.2,34.49-.56,23-.59,34.46c0,1.44,0,2.88,0,4.32,0,.1.15.09.15,0,.21-5.76.55-11.52.74-17.29s.36-11.55.5-17.33C184.87,360.82,185,349.26,184.82,337.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.69,269.49c-2.27-1.24-4.6-2.36-7-3.38s-4.83-1.94-7.2-3c-.09,0-.17.09-.08.14,2.34,1.2,4.63,2.49,7,3.63a56.72,56.72,0,0,0,7.17,2.87C156.75,269.8,156.83,269.56,156.69,269.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.09,416.69c0,2.22.08,4.42.14,6.54,0,1.32.08,2.61.12,3.85.27,8,.71,14.16,1.4,14.6,2.12,1.34,57.87,1.51,59.82.87s.24-6.25-1.92-8c-1.31-1.05-9.7-5-16.08-7.95l0,0c-4.1-1.89-7.37-3.36-7.37-3.36l.18-6.54.87-29.8H156.93S156.85,402.23,157.09,416.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.38,394.92c-1.13.19-40.65,0-40.65,0s.22,44.74,2.56,47.08,61.09,1.53,62.08.75-.07-6.47-4.23-10.11c-3-2.64-20.8-10.35-20.8-10.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,420.78c-3.37-1.63-7.86-2.26-11.26-.46-.13.07,0,.25.09.25a51.6,51.6,0,0,1,11,.65A.23.23,0,0,0,197.7,420.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,417.73c-3.37-1.63-7.86-2.26-11.26-.46-.13.07,0,.25.09.25a51.6,51.6,0,0,1,11,.65A.23.23,0,0,0,197.7,417.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,414.68c-3.37-1.63-7.86-2.26-11.26-.46-.13.07,0,.25.09.25a51.6,51.6,0,0,1,11,.65A.23.23,0,0,0,197.7,414.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,411.63c-3.37-1.63-7.86-2.26-11.26-.46-.13.07,0,.25.09.25a51.6,51.6,0,0,1,11,.65A.23.23,0,0,0,197.7,411.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,408.58c-3.37-1.63-7.86-2.26-11.26-.46-.13.07,0,.25.09.25a51.6,51.6,0,0,1,11,.65A.23.23,0,0,0,197.7,408.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.92,214.81l4.07,28s-48.23.67-59.56-.12c0,0,11.84-52.35,24-65.57,6.1-6.62,13.25-6.12,17.81-1.5,1.15,1.17,14.91,19.36,16.36,26.31C183.89,208.06,179.92,214.81,179.92,214.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.06,184.78c6.84,1,46.92-1.37,54-9.69,8.6-10.07,19-29.84,21.63-36.18,1.72-4.21-18.18-15-19.3-11-1.75,6.26-17.23,29.91-18.43,32s-19,8.21-29.37,13.39C157.29,177.94,153.24,184.05,158.06,184.78Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.16,128.81s2.26-8.32,4-13.69c1-3,3.09-8,4.81-9.85,2.57-2.81,15.1-12.9,17.61-9.91,2.28,2.7-9.59,10-9.59,10s11.33-8.43,13.46-4.67-12.37,10.23-12.37,10.23,11.84-8.4,13.43-4.17c1.2,3.19-11.61,9.79-11.61,9.79s10.22-7.15,11.6-3.92c1.53,3.57-9.92,10.4-9.92,10.4,2.13,8.81-.46,13.87-2.73,17.25C232.29,141.08,214.16,128.81,214.16,128.81Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.87,108c1.3-1,2.6-2.1,4-3s2.8-1.79,4.26-2.58a28.41,28.41,0,0,1,6-2.52,61.62,61.62,0,0,0-10,5.49c-1.38.91-2.8,1.76-4.18,2.68C226.87,108.1,226.84,108.05,226.87,108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.1,113.08c1.71-1.26,3.36-2.56,5.13-3.74s3.53-2.13,5.36-3.18c.15-.08.14,0,0,.11-1.79,1.12-3.36,2.29-5.13,3.43s-3.6,2.22-5.33,3.42C230.1,113.14,230.08,113.1,230.1,113.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.09,117.91a47.67,47.67,0,0,1,8.29-5.12c.14-.07.12.06,0,.15-2.79,1.65-5,2.92-8.2,5.06C232.11,118,232,118,232.09,117.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.93,162.12l9.74,21.07s-24.12,6.46-35.68,4.91c-8.35-1.12-8.07-7.76,3.44-14.61C172.52,168.08,185.93,162.12,185.93,162.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.24,183.39a194.59,194.59,0,0,0-8.63-19.11c0-.08-.15,0-.11.06.78,1.51,5.07,12.09,8.61,19.11C191.15,183.53,191.27,183.47,191.24,183.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.14,187.43c-3.78.55-7.39,2-11,3.16a.08.08,0,0,0,.05.15c1.39-.4,2.81-.76,4.23-1.13-.65.39-1.28.81-1.93,1.19-.09,0,0,.18.08.13,1-.57,2-1,3-1.63a46,46,0,0,0,5.59-1.79S175.2,187.42,175.14,187.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.66,127.93a12.13,12.13,0,0,1-2.08-6.71c0-8.49,9.33-15.38,20.84-15.38s20.82,6.89,20.82,15.38-9.32,15.39-20.82,15.39a25,25,0,0,1-14.37-4.26l-7.18,1.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.66,127.93a11.85,11.85,0,0,1-.56-12.9,16.51,16.51,0,0,1,4.59-5,22.11,22.11,0,0,1,6.07-3.12,28.39,28.39,0,0,1,6.7-1.37,28.92,28.92,0,0,1,6.83.33,22.68,22.68,0,0,1,12.22,5.94,14.58,14.58,0,0,1,3.67,5.87,11.89,11.89,0,0,1,.06,6.94,14.41,14.41,0,0,1-3.58,5.92,20.21,20.21,0,0,1-5.61,4,26.77,26.77,0,0,1-13.36,2.44,24.74,24.74,0,0,1-12.77-4.37l.18,0-7.2,1.71-.24.06.1-.22Zm0,0-2.68,6.3-.14-.17,7.15-1.93.1,0,.09.07a24.52,24.52,0,0,0,12.56,4,28.33,28.33,0,0,0,6.63-.47,24,24,0,0,0,6.29-2,19.36,19.36,0,0,0,5.34-3.82,13.44,13.44,0,0,0,3.31-5.55,11,11,0,0,0-.08-6.38,13.61,13.61,0,0,0-3.4-5.48,21.76,21.76,0,0,0-11.69-5.75,27.7,27.7,0,0,0-13.16.84,18.85,18.85,0,0,0-10.51,7.71,11.92,11.92,0,0,0-1.76,6.33A12.3,12.3,0,0,0,341.66,127.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.91,121.22a2.16,2.16,0,1,0,2.16-2.16A2.16,2.16,0,0,0,367.91,121.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.25,121.22a2.17,2.17,0,1,0,2.17-2.16A2.16,2.16,0,0,0,358.25,121.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.6,121.22a2.16,2.16,0,1,0,2.16-2.16A2.16,2.16,0,0,0,348.6,121.22Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamspiritCuate);
export default __webpack_public_path__ + "static/media/Team spirit-cuate.22bb0c55152eeb8bed7140e26a6b8fcd.svg";
export { ForwardRef as ReactComponent };